import { FC } from "react";
import { ITextLineProps } from "./types";

export const TextLine: FC<ITextLineProps> = ({ wide }) => (
  <span className={`flex self-start ${wide ? "w-12" : "w-10"} h-[2px] bg-secondary mt-[2px] mb-[7px]`}></span>
);
